import React from "react";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";
import FormErrorHandler from "../../components/FormErrorHandler";
import { Link } from "react-router";
import { scrollToElem } from "../../functions.js";

/**
 * These fields are required once they are set. They may not be cleared but when they
 * are not set yet, they are not required.
 * @type {string[]}
 */
const requiredWhenSet = ["email"];

export default class StudentsForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            originalData: {},
            editMode: props.params.itemID !== undefined,
            errorMessage: {},
            nibhv_number: null,
            eol_id: null,
            initials: "",
            first_name: "",
            last_name_prefix: "",
            last_name: "",
            email: "",
            date_of_birth: null,
            file: null,
            is_active: 1,
            language: "nl",
            read_only_fields: []
        };
    }

    updateElementState = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleDateChange = (date) => {
        this.setState({
            date_of_birth: date
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        let postData = {
            is_active: this.state.is_active,
            language: this.state.language,
            initials: this.state.initials,
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            last_name_prefix: this.state.last_name_prefix,
            date_of_birth: moment(this.state.date_of_birth).format("YYYY-MM-DD")
            // email: this.state.email,
        };

        // these fields could be blank already but if they are not, they shouldn't be cleared
        requiredWhenSet.forEach((field) => {
            if (this.state.originalData[field] || this.state[field]) {
                postData[field] = this.state[field];
            }
        });

        if (this.state.read_only_fields?.length) {
            // filter out read only fields
            postData = Object.keys(postData).reduce((acc, key) => {
                if (!this.state.read_only_fields.includes(key)) {
                    acc[key] = postData[key];
                }
                return acc;
            }, {});
        }

        if (this.state.editMode) {
            axios
                .patch("/v1/users/" + this.props.params.itemID + "/", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De cursist met e-mailadres '${this.state.email}' is succesvol bijgewerkt`,
                        link: `/students/edit/${response.data.uuid}`
                    });
                    this.props.router.push(`/students/view/${response.data.uuid}`);
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        } else {
            axios
                .post("/v1/students/?domain=cursist", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De cursist met e-mailadres '${this.state.email}' is succesvol opgeslagen`,
                        link: `/students/edit/${response.data.uuid}`
                    });
                    this.props.router.push(`/students/view/${response.data.uuid}`);
                })
                .catch((error) => {
                    if (error && error.response && error.response.data) {
                        this.setState({
                            errorMessage: error.response.data
                        });
                    }
                    scrollToElem(document.querySelector(".form-error"));
                });
        }
    };

    getResults = () => {
        if (this.state.editMode) {
            axios
                .get("/v1/users/" + this.props.params.itemID + "/")
                .then((response) => {
                    this.setState({
                        originalData: response.data,

                        nibhv_number: response.data.nibhv_number,
                        eol_id: response.data.eol_id,
                        initials: response.data.initials,
                        first_name: response.data.first_name,
                        last_name: response.data.last_name,
                        last_name_prefix: response.data.last_name_prefix,
                        email: response.data.email,
                        language: response.data.language,
                        date_of_birth: response.data.date_of_birth,
                        is_active: response.data.is_active ? 1 : 0,
                        read_only_fields: response.data.read_only_fields
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    componentDidMount() {
        this.getResults();
    }

    render() {
        return (
            <div>
                <div className="section-top">
                    <div className="breadcrumbs">
                        <Link to={"/students"}>Cursisten</Link>
                    </div>
                    <h1>Cursist {this.state.editMode ? "bewerken" : "toevoegen"}</h1>
                    {this.state.nibhv_number !== null ? <p className="lighter">NIBHV-nummer: {this.state.nibhv_number}</p> : false}
                    {this.state.eol_id !== null ? (
                        <p className="lighter mb-0">Deze gebruiker is gekoppeld met een Exact Online gebruiker, daardoor zijn een aantal velden niet te bewerken.</p>
                    ) : (
                        false
                    )}
                </div>

                <form onSubmit={this.handleSubmit} ref="formref">
                    <div className="row">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>Voorletters *</label>
                                        <input
                                            type="initials"
                                            tabIndex="1"
                                            name="initials"
                                            ref="initials"
                                            className="form-control form-control-md"
                                            required={true}
                                            autoFocus={true}
                                            onChange={this.updateElementState}
                                            value={this.state.initials || ""}
                                            readOnly={this.state.read_only_fields.includes("initials") || false}
                                        />
                                        <FormErrorHandler fieldName="initials" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Voornaam</label>
                                        <input
                                            type="first_name"
                                            tabIndex="1"
                                            name="first_name"
                                            ref="first_name"
                                            className="form-control form-control-md"
                                            required={false}
                                            onChange={this.updateElementState}
                                            value={this.state.first_name || ""}
                                            readOnly={this.state.read_only_fields.includes("first_name") || false}
                                        />
                                        <FormErrorHandler fieldName="first_name" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Tussenvoegsel</label>
                                        <input
                                            type="last_name_prefix"
                                            tabIndex="2"
                                            name="last_name_prefix"
                                            ref="last_name_prefix"
                                            className="form-control form-control-md"
                                            onChange={this.updateElementState}
                                            value={this.state.last_name_prefix === null ? "" : this.state.last_name_prefix}
                                            readOnly={this.state.read_only_fields.includes("last_name_prefix") || false}
                                        />
                                        <FormErrorHandler fieldName="last_name_prefix" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>Achternaam *</label>
                                        <input
                                            type="last_name"
                                            tabIndex="2"
                                            name="last_name"
                                            ref="last_name"
                                            className="form-control form-control-md"
                                            required={true}
                                            onChange={this.updateElementState}
                                            value={this.state.last_name || ""}
                                            readOnly={this.state.read_only_fields.includes("last_name") || false}
                                        />
                                        <FormErrorHandler fieldName="last_name" errorObject={this.state.errorMessage} />
                                    </div>

                                    <div className="form-group">
                                        <label>E-mailadres{this.state.originalData.email && " *"}</label>
                                        <input
                                            type="email"
                                            tabIndex="3"
                                            name="email"
                                            ref="email"
                                            className="form-control form-control-md"
                                            required={!!this.state.originalData.email}
                                            onChange={this.updateElementState}
                                            value={this.state.email || ""}
                                            readOnly={this.state.read_only_fields.includes("email") || false}
                                        />
                                        <FormErrorHandler fieldName="email" errorObject={this.state.errorMessage} />
                                    </div>

                                    <div className="form-group">
                                        <label>Geboortedatum</label>
                                        <DatePicker
                                            name="date_of_birth"
                                            customInput={<input type="text" className="form-control" onClick={this.props.onClick} {...this.props.value} />}
                                            onChange={this.handleDateChange}
                                            onChangeRaw={(event) => {
                                                let value = event.target.value.split("-").join("");
                                                let newDate = value.substring(0, 2);
                                                if (value.length >= 3) {
                                                    newDate += "-" + value.substring(2, 4);
                                                }
                                                if (value.length >= 5) {
                                                    let checkYear = value.substring(4, 8);
                                                    if (checkYear.length == 2 && checkYear != "19" && checkYear != "20") {
                                                        newDate += "-19" + value.substring(4, 8);
                                                    } else {
                                                        newDate += "-" + value.substring(4, 8);
                                                    }
                                                }
                                                event.target.value = newDate;
                                            }}
                                            className="form-control"
                                            required={false}
                                            placeholderText="Geboortedatum (dd-mm-yyyy)"
                                            selected={this.state.date_of_birth !== null ? moment(this.state.date_of_birth) : null}
                                            autoComplete="off"
                                            maxDate={moment()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            // disabled={this.state.read_only_fields.includes('date_of_birth') || false}
                                            readOnly={this.state.read_only_fields.includes("date_of_birth") || false}
                                        />
                                        <FormErrorHandler fieldName="date_of_birth" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                {!this.state.read_only_fields.includes("language") && (
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Taal van de cursist</label>
                                            <select
                                                tabIndex="5"
                                                className="form-control form-control-md"
                                                name="language"
                                                ref="language"
                                                onChange={this.updateElementState}
                                                value={this.state.language}
                                            >
                                                <option value="nl">Nederlands</option>
                                                <option value="en">Engels</option>
                                            </select>
                                            <FormErrorHandler fieldName="language" errorObject={this.state.errorMessage} />
                                        </div>
                                    </div>
                                )}
                                {!this.state.read_only_fields.includes("is_active") && (
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Actief</label>
                                            <select
                                                tabIndex="6"
                                                className="form-control form-control-md"
                                                name="is_active"
                                                ref="is_active"
                                                onChange={this.updateElementState}
                                                value={this.state.is_active}
                                            >
                                                <option value="1">Ja</option>
                                                <option value="0">Nee</option>
                                            </select>
                                            <FormErrorHandler fieldName="is_active" errorObject={this.state.errorMessage} />
                                        </div>
                                    </div>
                                )}
                            </div>

                            <FormErrorHandler fieldName="non_field_errors" errorObject={this.state.errorMessage} />

                            <div className="form-group">
                                <button className="btn btn-primary" type="submit">
                                    Opslaan
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}
